export const routePageNameMap = {
    "/": "dashboard",

    "/collections/status": "collection_status",
    "/collections/errors": "collection_error",
    "/collections/errors/patterns": "collections_error", // collections_error와 동일시
    "/collections/size": "collection_data_size",
    "/collections/e2e-dashboard": "e2e_test_dashboard",

    "/preferences/collection": "prism_config",
    "/preferences/universal-throttling": "universal_throttling",
    "/preferences/anomaly-detection-rules": "anomaly_detection",
    "/preferences/data-forwarder-policy": "data_forwarder",
    "/preferences/facebook-resource-date": "facebook_resource_target_date",
    "/preferences/channel-collection-delay": "collection_delay_threshold",

    "/recover/data-forwarder-reprocess": "data_forwarder_retry",
    "/recover/appsflyer-raw-file-delete": "delete_apps_raw",

    "/organization/onboarding": "onboarding",
    "/organization/offboarding": "offboarding",

    "/tokens/tms": "tms_token_management",

    "/users/permission-groups": "prism_backoffice_user_grant_group",
    "/users": "prism_backoffice_user",

    "/info/media-api-version": "media_api_version",
    "/info/workspace-search": "search_workspace",
    "/info/media-version-update-alert-settings": "versioning_schedule_check",
    "/info/trend-data-management": "trend_data_management",
} as const;